// import React, { useEffect, useState, useRef } from "react";
import { AxiosResponse } from "axios";
import BaseModel from "../models/BaseModel";

import axios, { getBaseUrl } from "../utils/axios";
import BaseStorageHandler from "./BaseStorageHandler";
import ZipStorageHandler from "./ZipStorageHandler";
import axiosInstance from "../utils/axios";
import Logger from "../Logger";
import { newId } from "../models/BaseObject";
import { showErrToast, updateToastProgress } from "../components/Toasts";
import { itx } from "../translationItx/itx";
import { EP } from "../performance/PerfomanceItem";
import { cleanEncode } from "../utils/CommonUtils";
import ProjectMetadata from "../models/ProjectMetadata";

const logger = new Logger();

const CLASSNAME = "ServerDataBaseHandler"; // no itx

export default class ServerDataBaseHandler implements BaseStorageHandler {
  get isLocalStorgeHandle() {
    return false;
  }

  isSuccess(response: AxiosResponse) {
    if (response.data?.STATUS == "SUCCESS") {
      return true;
    } else if (response.status == 200) {
      return true;
    }
    return false;
    // return response.data?.STATUS == "SUCCESS";
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // Project Items
  ///////////////////////////////////////////////////////////////////////////////////

  //
  // delete all projectItems of one project
  //
  async deleteProjectItems(projectId: string): Promise<boolean> {
    const response = await axios.delete("/api/projectitems/" + projectId);
    return this.isSuccess(response);
  }

  //
  // save one projectItem
  //
  // this function is forewarded as callback to the recursive calls of "saveToEstadaStorage" in the model hierachie
  //
  saveData = async (item: BaseModel): Promise<boolean> => {
    (item as any).projectId = state.projectMetadata.id;
    try {
      const response = await axios.put(`/api/projectitems/item`, item);
      return this.isSuccess(response);
    } catch (ex) {
      logger.error("saveData", ex, item);
    }
    return false;
  };

  //
  // save all project items
  // calls "saveData" for each item
  //
  async saveProjectItems2(projectId: string, blob: Blob): Promise<boolean> {
    const data = new FormData();
    data.set("data", blob, "data");

    const response = await axios.post(`/api/project/itemsasblob/${cleanEncode(projectId)}`, data, {
      onUploadProgress: (progressEvent: any) => {
        try {
          const current = progressEvent.progress * 100; // 70% of the total progress
          const size = progressEvent.total;
          const rate = progressEvent.rate;

          updateToastProgress({ progress: current });
        } catch (ex) {}
      },
    });

    return this.isSuccess(response);
  }

  //
  // load save Panel Configuration
  //
  async savePanelData(id: string, sData: string): Promise<boolean> {
    try {
      const blob = new Blob([sData], {
        type: "text/plain",
      });
      const data = new FormData();
      data.set("data", blob, "data");

      const response = await axios.post(`/api/project/itemsasblob/${cleanEncode(id)}`, data);

      return this.isSuccess(response);
    } catch (ex) {
      logger.error(ex);
      return false;
    }
  }

  async loadPanelData(id: string): Promise<string | undefined> {
    try {
      const response = await axios.get(`/api/project/itemsasblob/${cleanEncode(id)}`, {
        responseType: "blob",
      });
      if (this.isSuccess(response)) {
        const blob = response.data;
        const text = await blob.text();
        return text;
      }
    } catch (ex) {
      logger.error(ex);
    }
    return undefined;
  }

  //
  // load save AllSignal Configuration
  //
  async saveAllSignalData(sData: string, manufacturorId: string): Promise<boolean> {
    const id = "@allSignals" + manufacturorId; // no itx
    try {
      const blob = new Blob([sData], {
        type: "text/plain",
      });
      const data = new FormData();
      data.set("data", blob, "data");

      const response = await axios.post(`/api/project/itemsasblob/${cleanEncode(id)}`, data);

      return this.isSuccess(response);
    } catch (ex) {
      logger.error(ex);
      return false;
    }
  }

  async loadAllSignalData(saveId: string): Promise<string | undefined> {
    const id = "@allSignals" + saveId; // no itx
    try {
      const response = await axios.get(`/api/project/itemsasblob/${cleanEncode(id)}`, {
        responseType: "blob",
      });
      // ERROR!???: status == 200 even if response.data.text().statusCode == 404????
      // Server sending wrong status code?
      if (this.isSuccess(response)) {
        const blob = response.data;
        const text = await blob.text();
        return text;
      }
    } catch (ex) {
      logger.error(ex);
    }
    return undefined;
  }
  //
  // load one projectItem
  //
  // this function is forewarded as callback to the recursive calls of "loadFromEstadaStorage" in the model hierachie
  //
  async loadData(id: string | undefined, parentId: string | undefined): Promise<any> {
    try {
      if (id) {
        const response = await axios.get(`/api/projectitems/item/${cleanEncode(id)}`);
        if (this.isSuccess(response)) {
          return response.data.DATA;
        }
      } else if (parentId) {
        const response = await axios.get(`/api/projectitems/children/${cleanEncode(parentId)}`);
        if (this.isSuccess(response)) {
          return response.data.DATA;
        }
      } else {
        logger.error(`parameter error`);
      }
    } catch (ex) {
      logger.error(ex);
    }

    return undefined;
  }

  async loadProjectItems(projectId: string): Promise<Blob | undefined> {
    const ep = EP(CLASSNAME + ".loadProjectItems"); // no itx
    ep.start();

    state.id = newId();

    try {
      //
      // dummy query to force "NO CACHE"
      //
      let d = `${new Date().getTime()}`;
      d = "x;"; // no itx

      let response;

      await EP(CLASSNAME + ".loadProjectItems-Server").runAsync(async () => {
        response = await axios.get(`/api/project/itemsasblob/${cleanEncode(projectId)}?${d}`, {
          responseType: "blob",
          // query URL without using browser cache
          headers: {
            "Cache-Control": "no-cache", // no itx
            Pragma: "no-cache", // no itx
            Expires: "0",
          },
          onDownloadProgress: (progressEvent: any) => {
            try {
              const current = progressEvent.progress * 100;
              const size = progressEvent.total;
              const rate = progressEvent.rate;

              updateToastProgress({ progress: current * 0.7 });
            } catch (ex) {}
          },
        });
      });

      updateToastProgress({ progress: 70 });

      if (response.status == 200) {
        const z = new ZipStorageHandler();
        const blob = response.data as Blob;
        let isValidZip = false;

        await EP(CLASSNAME + ".loadProjectItems-Unzip").runAsync(async () => {
          isValidZip = await z.setBlob(blob);
        });

        if (isValidZip) {
          await EP(CLASSNAME + ".loadProjectItems-Load").runAsync(async () => {
            await z.loadProjectItemsFromZip(projectId);
            await z.loadDeletedIds();
          });
        } else {
          showErrToast(itx("ServerDataBaseHandler.systemErrorProjectCorrupted", "System-Error: Project is corrupted"));

          ep.stop();
          return undefined;
        }

        ep.stop();
        return blob;
      }
    } catch (ex) {
      logger.error(ex);

      ep.stop();
      return undefined;
    }
  }

  async loadProjectItemsBlob(projectId: string): Promise<Blob | undefined> {
    try {
      const response = await axios.get(`/api/project/itemsasblob/${cleanEncode(projectId)}?raw`, {
        responseType: "blob",
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache", Expires: "0" },
      });
      return response.status === 200 ? (response.data as Blob) : undefined;
    } catch (ex) {
      logger.error(ex);
      return undefined;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // Metadata
  ///////////////////////////////////////////////////////////////////////////////////

  async deleteProjectMetadata(projectId: string): Promise<boolean> {
    try {
      const response = await axios.delete(`/api/project/${projectId}`);
      return response.data.STATUS == "SUCCESS";
    } catch (ex) {
      logger.error(`saveProjectMetadata FAILED`, ex);
      return false;
    }
    return false;
  }

  async loadProjectMetadata(projectId: string): Promise<any> {
    var ex: any = undefined;

    try {
      const response = await axios.get(`/api/project/${projectId}`, {
        headers: { "Cache-Control": "no-cache", Pragma: "no-cache", Expires: "0" },
      });
      if (response.data.STATUS == "SUCCESS") {
        return response.data.DATA;
      }
    } catch (ex1) {
      ex = ex1;
    }

    logger.error(`loadProjectMetadata FAILED`, ex);
    return undefined;
  }

  async saveProjectMetadata(projectId: string, data: ProjectMetadata): Promise<boolean> {
    try {
      //
      // dont save localCopied to the server
      // localCopied is only for the localStorage
      //
      delete data.localCopied;
      delete data.lastModifiedLocal;
      /////////////////////////////////////////////////////////////////

      const response = await axios.put(`/api/project`, data);
      let res = response.data.STATUS == "SUCCESS";
      if (!res) {
        let t1 = itx(`saveProject.${response.data.MESSAGE?.replaceAll(" ", "")}`, response.data.MESSAGE);

        showErrToast(
          state.translate("saveProject.projectCoudnTSaveT1", `Ihr Projekt konnte NICHT gespeichert werden T1`, {
            T1: t1,
          }),
        );
      }
      return res;
    } catch (ex) {
      logger.error(`saveProjectMetadata FAILED`, ex);
      return false;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////
  // Projectlist
  ///////////////////////////////////////////////////////////////////////////////////

  async loadProjectList(user: string): Promise<any> {
    const ep = EP(CLASSNAME + ".loadProjectList"); // no itx
    ep.start();
    try {
      const response = await axiosInstance.get(`/api/projectlist/${user}`);
      if (response.data.STATUS == "SUCCESS") {
        const projectDatas = response.data.DATA;
        // convert result to an array of ProjectMetadata
        // we cant work with just an array of objects
        const res = new Array<any>();
        for (let i = 0; i < projectDatas.length; i++) {
          // const item = new ProjectMetadata();
          // item.fromJSON(projectDatas[i]);
          res.push(projectDatas[i]);
        }

        ep.stop();
        return res;
      } else {
        ep.stop();
        return [];
      }
    } catch (ex) {
      logger.error(`loadProjectList FAILED`, ex);
      if (!navigator.onLine) {
        // Handle scenario if user is offline
      }

      ep.stop();
      return [];
    }
  }
  ///////////////////////////////////////////////////////////////
  //calculate user
  ///////////////////////////////////////////////////////////////
  //// calculate muelmail users
  async calcMails(
    type: "UsersWithoutPojects" | "muellMailUsers", // no itx
  ) {
    function downloadTextFile(name: string, text: string) {
      try {
        const link = document.createElement("a");

        const file = new Blob([text], { type: "text/plain" });
        link.href = URL.createObjectURL(file);
        link.download = `${name}.txt`;

        link.click();
        URL.revokeObjectURL(link.href);
      } catch (ex) {
        logger.error("download Text File not possible", [ex, name, text]);
      }
    }
    // get all users first
    axios
      .post(`/api/userList`)
      .then(async (result: any) => {
        if (result.data.STATUS != "SUCCESS") {
          return;
        }

        // check if they end with muellmail ends
        const endings = [
          "bung.holio.day", // no itx
          "10minmail.de", // no itx
          "10minutenmail.xyz", // no itx
          "existiert.net", // no itx
          "fliegender.fish", // no itx
          "jaga.email", // no itx
          "mdz.email", // no itx
          "muellmail.com", // no itx
          "muellemail.com", // no itx
          "muell.icu", // no itx
          "muell.io", // no itx
          "muell.xyz", // no itx
          "muell.monster", // no itx
          "magspam.net", // no itx
          "fukaru.com", // no itx
          "oida.icu", // no itx
          "papierkorb.me", // no itx
          "spam.care", // no itx
          "tonne.to", // no itx
          "ultra.fyi", // no itx
          "wegwerfemail.de", // no itx
          "dsgvo.party", // no itx
          "knickerbockerban.de", // no itx
          "lambsauce.de", // no itx
          "ramenmail.de", // no itx
          "ji5.de", // no itx
          "ji6.de", // no itx
          "ji7.de", // no itx
          "sudern.de", // no itx
          "hihi.lol", // no itx
          "keine.date", // no itx
          "holio.day", // no itx
          "corn.holio.day", // no itx
          "stacys.mom", // no itx
        ];
        // result.data.DATA is a object

        const emails = result.data.DATA;

        const usersWithNumberOfProjects = new Array<{ email: string; projectCount: number }>();
        for (const i in result.data.DATA) {
          const userEmail = emails[i];
          // check if they have projects
          const projects = await this.loadProjectList(userEmail);
          if (type == "muellMailUsers") {
            const ending = userEmail.split("@")[1];
            if (ending && endings.includes(ending)) {
              // Write a list of the users
              usersWithNumberOfProjects.push({ email: userEmail, projectCount: projects.length });
            }
          } else {
            usersWithNumberOfProjects.push({ email: userEmail, projectCount: projects.length });
          }
        }

        let text = type;
        text += `
emails without Projects`;
        let emailsWithoutProjects = "";
        let allOtherEmails = "";
        let countEmailsWithoutProjects = 0;
        usersWithNumberOfProjects.forEach(({ email, projectCount }) => {
          if (projectCount == 0) {
            countEmailsWithoutProjects++;
            if (emailsWithoutProjects != "") {
              emailsWithoutProjects += ",";
            }
            emailsWithoutProjects += `
"${email}"`;
          } else {
            allOtherEmails += `
${email}|${projectCount}`;
          }
        });

        text +=
          `
{email:{ $in: [ ` +
          emailsWithoutProjects +
          `] }}
  
  `;
        text += `
          
  total  Adresses: ${countEmailsWithoutProjects}`;
        if (type == "muellMailUsers") {
          text += `
          emails | projektanzahl`;
          text += allOtherEmails;
          text += `
          
total muellmail Adresses: ${usersWithNumberOfProjects.length}`;
        }

        downloadTextFile(type, text);
        console.log(text);
      })
      .catch((e) => {
        logger.log("", e);
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // User

  async userIsLoggedIn(): Promise<boolean> {
    try {
      const response = await axios.post(`/api/checkSessionIsActive`);
      if (response.data.STATUS == "SUCCESS") {
        return response.data.DATA.isActive;
      } else {
        return false;
      }
    } catch (ex) {
      logger.error(`userIsLoggedIn FAILED`, ex);
      return false;
    }
  }

  //
  // returns undefined if fails
  //
  async login(params: { email: string; password: string }): Promise<any | undefined> {
    try {
      const result = await axios.post("/api/login", params);
      if (result.data.DATA.token) {
        result.data.DATA.password = params.password;
        let pfp = result.data.DATA?.profile_pic;
        let starred = result.data.DATA?.favourited_projects;
        if (pfp) {
          localStorage.setItem(`profilePicture${result.data.DATA.id || ""}`, pfp);
        }
        if (starred) {
          localStorage.setItem("favoriteSelectedProjects", starred);
        }

        localStorage.setItem("user", JSON.stringify(result.data.DATA));

        return result.data.DATA;
      } else {
        return undefined;
      }
    } catch (e) {
      logger.error("login failed", e);
      return undefined;
    }
  }

  //////////////////////////////////////////////////////////////

  async loadPdfFile(id: string): Promise<Blob | undefined> {
    try {
      const response = await axios.get(`/api/project/itemsasblob/${cleanEncode(id)}`, {
        responseType: "blob",
      });

      if (response.status == 200) {
        const blob = response.data;
        return blob;
      }
    } catch (ex) {
      logger.error(ex);
    }
    return undefined;
  }

  async savePdfFile(id: string, blob: Blob): Promise<boolean> {
    try {
      const data = new FormData();
      data.set("data", blob, "data");

      const response = await axios.post(`/api/project/itemsasblob/${cleanEncode(id)}`, data);

      return this.isSuccess(response);
    } catch (ex) {
      logger.error(ex);
    }
    return false;
  }

  static async serverIsOnline(): Promise<boolean> {
    if (navigator.onLine) {
      try {
        const response = await fetch(`${getBaseUrl()}/api/ping`, { signal: AbortSignal.timeout(5000) });
        return response.status == 200;
      } catch (ex: any) {
        if (ex.name === "TimeoutError") {
          console.log("5000 ms timeout");
        } else {
          logger.log((ex as any).message);
        }
      }
    }

    return false;
  }

  installationCheckId(projectId: string, ownerId: string): string {
    return `I-${projectId}-${ownerId}`;
  }

  async saveInstallationChecks(projectId: string, ownerId: string, item: any): Promise<boolean> {
    try {
      const result = await axios.post("/api/saveInstallationChecks", {
        projectId: projectId,
        ownerId: ownerId,
        data: item,
      });

      if (result.data.STATUS !== "SUCCESS") {
        logger.error("Failed to save InstallationCheck", result.data);
        return false;
      }
    } catch (ex) {
      logger.error(ex);
    }

    return true;
  }

  async loadInstallationChecks(projectId: string, ownerId: string): Promise<any | undefined> {
    try {
      const result = await axios.post("/api/loadInstallationChecks", { projectId: projectId, ownerId: ownerId });
      if (result.data.DATA) {
        return result.data.DATA;
      }
    } catch (ex) {
      logger.error(ex);
    }
    return undefined;
  }
}
